import { ClubPages } from './ClubPages';

export default ClubPages;
